

















import Vue from 'vue';
import JerseyButton from '@/components/elements/JerseyButton.vue';

export default Vue.extend({
  name: 'JerseyHeader',
  components: { JerseyButton },
  props: {},
  mounted() {},
  methods: {},
});
